import { FC } from 'react';
import { PaymentTypeId } from '@/types/payment';
import { isPaidy, switchPaymentIcon, PAIDY_LOGO_URL } from '@/utils/payment';

interface PaymentIconProps {
  paymentTypeId: PaymentTypeId | number | undefined;
  className?: string;
}

export const PaymentIcon: FC<PaymentIconProps> = ({
  paymentTypeId,
  className = '',
}) => {
  if (isPaidy(paymentTypeId)) {
    return (
      <img
        src={PAIDY_LOGO_URL}
        alt="ペイディ"
        style={{
          width: '57px',
          height: 'auto',
          objectFit: 'contain',
          verticalAlign: 'middle',
        }}
      />
    );
  }
  return (
    <i
      className={`${className} ${switchPaymentIcon(
        paymentTypeId as PaymentTypeId,
      )}`}
    />
  );
};
